<template>
  <div class="batches-tab">
    <v-progress-linear class="loading" v-show="loading" :indeterminate="true"></v-progress-linear>
    <search-input :search="this.search" placeholder="Search" @on-search="handleSearch"></search-input>
    <div v-show="!loading" class="total-ctn">{{batchCount}} {{ batchCount ? 'batches' : 'batch' }} found.</div>
    <list v-show="!loading">
      <list-item v-for="batch in batches" @handle-click="handleClick(batch)" :key="batch.id" :selected="selectedBatch.id === batch.id" slot="item">
        <batch-item :batch="batch">
        </batch-item>
      </list-item>
      <info-card v-show="selectedBatch.id" slot="info-card">
        <batch-card @click-submit="handleSubmitClick()" @view-lot-details="handleViewLotDetails" :batch="selectedBatch"></batch-card>
      </info-card>
    </list>
  </div>
</template>

<script>

import List from '@/components/List'
import ListItem from '@/components/ListItem'
import InfoCard from '@/components/InfoCard'

import BatchItem from '@/components/BatchItem'
import BatchCard from '@/components/BatchCard'

import SearchInput from '@/components/SearchInput'

import { mapGetters } from 'vuex'

export default {
  name: 'BatchesTab',
  components: {
    'list': List,
    'list-item': ListItem,
    'batch-item': BatchItem,
    'info-card': InfoCard,
    'batch-card': BatchCard,
    'search-input': SearchInput
  },
  computed: mapGetters({
    selectedBatch: 'selectedBatch',
    batches: 'filteredBatches',
    lotList: 'lotList',
    loading: 'batchLoading',
    profile: 'profile',
    batchCount: 'batchCount'
  }),
  data () {
    return {
      search: ''
    }
  },
  methods: {
    handleClick (batch) {
      this.$store.dispatch('selectBatch', { batch: batch })
    },
    handleSearch (search) {
      this.$store.dispatch('clearBatchSelection')
      this.$store.dispatch('searchBatch', search)
    },
    handleViewLotDetails (lotId) {
      this.$router.push({ path: 'lots', query: { search: lotId } })
    }
  },
  created () {
    this.$store.dispatch('loadBatchList')
    this.$store.dispatch('loadPackagingPlant')
    this.$store.dispatch('loadIngredientList')
    if (!this.lotList.length) {
      let owner = this.profile.organization.role === 'brand' ? '' : this.profile.organization.id
      this.$store.dispatch('loadLotList', { owner: owner })
    }
  }
}

</script>

<style lang="scss" scoped>

.batches-tab{
  padding: 0px;
  background: white;
  position: relative;
}

.loading{
  position: absolute;
  margin-top: 0px;
  top: 0px;
}

.total-ctn{
  padding-left: 16px;
  padding-top: 15px;
  font-size: 15px;
  font-weight: bold;
}

</style>
